import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  ChakraProvider
} from '@chakra-ui/react';


class DialogManager {
  constructor() {
    this.activeContainer = null;
    this.activeRoot = null;
    this.isOpen = false;
  }

  open({ onAccept = () => true, onDeny = () => true, acceptText, denyText, body, header, isClosable = true, theme }) {
    // If there’s already an open dialog, return
    if (this.isOpen) {
      return;
    }
    this.isOpen = true;

    this.activeContainer = document.createElement('div');
    document.body.appendChild(this.activeContainer);
    this.activeRoot = createRoot(this.activeContainer);

    const _cleanup = () => {
      if (this.activeRoot) {
        this.activeRoot.unmount();
        this.activeRoot = null;
      }
      if (this.activeContainer) {
        document.body.removeChild(this.activeContainer);
        this.activeContainer = null;
      }
      this.isOpen = false;
    };

    this.activeRoot.render(
      <ChakraProvider theme={theme}>
        <Modal
          isOpen={true}
          onClose={isClosable ? () => {
            onDeny();
            _cleanup();
          } : undefined}
          closeOnOverlayClick={isClosable}
          closeOnEsc={isClosable}
        >
          <ModalOverlay/>
          <ModalContent>
            <ModalHeader>{header}</ModalHeader>
            {isClosable && <ModalCloseButton onClick={() => {
              onDeny();
              _cleanup();
            }}/>}
            <ModalBody>{body}</ModalBody>
            <ModalFooter>
              {denyText && (
                <Button
                  variant="ghost"
                  onClick={() => {
                    onDeny();
                    _cleanup();
                  }}
                >
                  {denyText}
                </Button>
              )}
              {acceptText && (
                <Button
                  colorScheme="blue"
                  mr={3}
                  onClick={() => {
                    onAccept();
                    _cleanup();
                  }}
                >
                  {acceptText}
                </Button>
              )}
            </ModalFooter>
          </ModalContent>
        </Modal>
      </ChakraProvider>
    );
  }

  close() {
    if (this.activeRoot) {
      this.activeRoot.unmount();
      this.activeRoot = null;
    }
    if (this.activeContainer) {
      document.body.removeChild(this.activeContainer);
      this.activeContainer = null;
    }
    this.isOpen = false;
  }
}

const dialogManager = new DialogManager();
export default dialogManager;